import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dd4da7dc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=dd4da7dc&prod&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=dd4da7dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4da7dc",
  null
  
)

export default component.exports